import { Box } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { FormTitleBox, TableBodySkeleton } from '../../common/components';
import SupplyOrdersDataTable from './components/SupplyOrdersDataTable';
import SupplyOrdersPagination from './components/SupplyOrdersPagination';
import SupplyOrdersFilters from './components/SupplyOrdersFilters';
import SupplyOrderDialog from './components/SupplyOrderDialog';
import SupplyOrderDetailDialog from './components/SupplyOrderDetailDialog';
import { useSupplyOrdersTable } from './hooks/useSupplyOrdersTable';

const SupplyOrdersTable = () => {
  const {
    data,
    isLoading,
    isSaving,
    isProcessing,
    page,
    totalPages,
    totalCount,
    rowsPerPage,
    filters,
    dialogOpen,
    editDialogOpen,
    detailDialogOpen,
    selectedOrder,
    selectedOrderDetail,
    detailOrderLoading,
    warehouses,
    providers,
    warehousesLoading,
    providersLoading,
    handlePageChange,
    handleRowsPerPageChange,
    handleFilterChange,
    handleOpenDialog,
    handleCloseDialog,
    handleCloseEditDialog,
    handleInputChange,
    handleSelectChange,
    handleAddMaterial,
    handleUpdateMaterialQuantity,
    handleRemoveMaterial,
    handleSave,
    handleUpdate,
    handleViewDetail,
    handleCloseDetailDialog,
    handleOpenEditDialog,
    handleEditFromDetail,
    handleRefreshDetailOrder,
    issueMutation,
    markSentMutation,
    acknowledgeMutation,
    receiveMutation,
    cancelMutation,
    closeMutation,
    printMutation,
  } = useSupplyOrdersTable();

  return (
    <Box>
      <FormTitleBox
        title="Stock y Compras | Órdenes de materiales a proveedores"
        showButton={true}
        buttonText="Nueva orden a proveedor"
        buttonIcon={AddShoppingCartIcon}
        onButtonClick={handleOpenDialog}
        showSearch={false}
      />

      <SupplyOrdersFilters
        filters={filters}
        warehouses={warehouses}
        providers={providers}
        onFilterChange={handleFilterChange}
        onSelectChange={handleFilterChange}
      />

      <SupplyOrdersDataTable
        data={data}
        isLoading={isLoading}
        onView={handleViewDetail}
        onEdit={handleOpenEditDialog}
        LoadingComponent={TableBodySkeleton}
      />

      {totalPages > 1 && (
        <SupplyOrdersPagination
          totalPages={totalPages}
          totalCount={totalCount}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      )}

      <SupplyOrderDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedOrder={selectedOrder}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleSave}
        warehouses={warehouses}
        warehousesLoading={warehousesLoading}
        providers={providers}
        providersLoading={providersLoading}
        searchEnabled={dialogOpen}
        onAddMaterial={handleAddMaterial}
        onUpdateMaterialQuantity={handleUpdateMaterialQuantity}
        onRemoveMaterial={handleRemoveMaterial}
        isSaving={isSaving}
        providerOnly
      />

      <SupplyOrderDialog
        open={editDialogOpen}
        onClose={handleCloseEditDialog}
        selectedOrder={selectedOrder}
        onInputChange={handleInputChange}
        onSelectChange={handleSelectChange}
        onSave={handleUpdate}
        warehouses={warehouses}
        warehousesLoading={warehousesLoading}
        providers={providers}
        providersLoading={providersLoading}
        searchEnabled={editDialogOpen}
        onAddMaterial={handleAddMaterial}
        onUpdateMaterialQuantity={handleUpdateMaterialQuantity}
        onRemoveMaterial={handleRemoveMaterial}
        isSaving={isSaving}
        isEditMode
      />

      <SupplyOrderDetailDialog
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
        order={selectedOrderDetail}
        isLoading={detailOrderLoading}
        onEdit={handleEditFromDetail}
        onIssue={(id) => issueMutation.mutateAsync(id).then(handleRefreshDetailOrder)}
        onMarkSent={(params) =>
          markSentMutation.mutateAsync(params).then(handleRefreshDetailOrder)
        }
        onAcknowledge={(id) =>
          acknowledgeMutation.mutateAsync(id).then(handleRefreshDetailOrder)
        }
        onReceive={(params) =>
          receiveMutation.mutateAsync(params).then(handleRefreshDetailOrder)
        }
        onCancel={(params) =>
          cancelMutation.mutateAsync(params).then(handleRefreshDetailOrder)
        }
        onCloseOrder={(params) =>
          closeMutation.mutateAsync(params).then(handleRefreshDetailOrder)
        }
        onPrint={(id) => printMutation.mutateAsync(id)}
        isProcessing={isProcessing}
      />
    </Box>
  );
};

export default SupplyOrdersTable;
